import { render, staticRenderFns } from "./RedirectToTenantStartView.vue?vue&type=template&id=212215a1&scoped=true"
import script from "./RedirectToTenantStartView.vue?vue&type=script&lang=js"
export * from "./RedirectToTenantStartView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212215a1",
  null
  
)

export default component.exports